/**
 * 모바일 레이아웃 적용 상한(px). `src/app/responsive.scss`의 `$breakpoint-mobile`, 디자인 `mobile-breakpoint` 토큰과 같은 값이다.
 */
export const MOBILE_BREAKPOINT = 768;

/**
 * PC에서 시트·모달·토스트처럼 가운데 열로 띄우는 요소의 폭(px). `--mobile-column-width`와 같은 값이다.
 */
export const MOBILE_COLUMN_WIDTH = 480;

/** PC 레이아웃이 시작하는 미디어 쿼리. */
export const PC_MEDIA_QUERY = `(min-width: ${MOBILE_BREAKPOINT + 1}px)`;

/** PC masonry가 3열이 되는 폭(px). 그보다 좁은 PC(769–1279px)는 2열이다. `$breakpoint-pc-three-column`과 같은 값이다. */
export const PC_THREE_COLUMN_BREAKPOINT = 1280;

/** PC masonry 3열 미디어 쿼리. */
export const PC_THREE_COLUMN_MEDIA_QUERY = `(min-width: ${PC_THREE_COLUMN_BREAKPOINT}px)`;

/** PC masonry 카드 사이 가로·세로 간격(px). */
export const PC_MASONRY_GAP = 24;
